import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import { Box, BoxTitle, Content, ContentTitle, StakeInput } from "../baseItems";
import Base from "./base";

export default class Vpag extends Base {
	getStep1(translate) {
		const { method } = this.props;
		const {
			stake,
			selectedCurrency,
			crypto_currency,
			crypto_payway,
			doc_type,
			banks,
			cards,
			bank_id,
			bank_code,
			account_type,
			card,
		} = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<Fragment>
					{method === "Vcreditos" && (
						<FormItem
							onRegister={() => this.registerField({ name: "vcreditos_user_id" })}>
							<Box>
								<BoxTitle>{translate("USER_ID")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									type="number"
									onChange={this.onEnterValue.bind(this, "vcreditos_user_id")}
								/>
							</Box>
						</FormItem>
					)}
					{method === "VpagWallet" && (
						<FormItem onRegister={() => this.registerField({ name: "vpag_username" })}>
							<Box>
								<BoxTitle>{translate("VPAG_USERNAME")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									onChange={this.onEnterValue.bind(this, "vpag_username")}
								/>
							</Box>
						</FormItem>
					)}
				</Fragment>
			</Content>
		);
	}

	makeExternalPayment() {
		const { method } = this.props;
		const {
			stake,
			pixkey,
			account_number,
			selectedCurrency,
			crypto_currency,
			doc_number,
			crypto_payway,
			doc_type,
			banks,
			bank_id,
			bank_code,
			account_type,
			vcreditos_user_id,
		} = this.state;
		let vcreditosUserId = vcreditos_user_id;
		let withdrawData = {
			method: "Vcreditos",
			vcreditos_user_id: vcreditosUserId,
			pixkey,
			type: "Vcreditos",
			account_number,
			crypto_currency,
			doc_number,
			crypto_payway,
			doc_type,
			bank_id,
			bank_code,
			account_type,
			username: getUser().username,
			sessionId: getUser().sessionId,
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
